module.exports = __webpack_public_path__ + "fonts/museo-sans-700-webfont.bba5910.ttf";